import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'sticky',
    bottom: 0,
    width: '100%',
    backgroundColor: $theme.colors.white,
    borderTop: '1px solid #D9D9D9',
    alignItems: 'center',

    [$theme.mediaQuery.medium]: {
        justifyContent: 'space-around'
    },

    [$theme.mediaQuery.large]: {
        justifyContent: 'space-between'
    }
}))

export const NavItem = styled<'a', { $selected: boolean }>('a', ({ $theme, $selected }) => ({
    color: $selected ? $theme.colors.primary : $theme.colors.black,
    flex: 1,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justityContent: 'center',
    cursor: 'pointer',
    padding: `${$theme.sizing.scale600} 0`,
    transition: 'background-color 0.3s ease',

    ':active': {
        backgroundColor: '#D9D9D9'
    }
}))

export const NavItemIcon = styled('i', ({ $theme }) => ({
    fontSize: $theme.sizing.scale800
}))

export const NavItemText = styled('span', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall
    // marginTop: '7px'
}))
